import { Component } from '@angular/core';

@Component({
  selector: 'app-action-sheet-button',
  templateUrl: './action-sheet-button.component.html',
})
export class ActionSheetButtonComponent {

}
